// libs
import React from 'react';
import PropTypes from 'prop-types';

// Props and Context
const propTypes = {
  medias: PropTypes.array.isRequired,
};
const defaultProps = {};
const contextTypes = {
  t: PropTypes.func,
};

function SuggestionsMedias({ medias }, { t }) {
  return (
    <div>
      <strong>{t('pages.single.suggestionsMedias')}</strong>
      <ul className="suggestions-list suggestions-list--media">
        {medias.map(({ media_type: mediaType, title, ...media }) => (
          mediaType === 'roman' ?
            <li
              key={`media-${mediaType}-${title}`}
              className="book"
            >
              {media.author} ({media.year}). <em>{title}</em>.<br />
              {media.publication_location} : {media.publishing_house}, {media.page_number} p.
            </li>
          :
            <li
              key={`media-${mediaType}-${title}`}
              className="movie"
            >
              {media.realisator}. <em>{title}</em> [{media.format}],<br />
              {media.distributor}, {media.year}, {media.duration} minutes
            </li>
          ),
        )}
      </ul>
    </div>
  );
}

SuggestionsMedias.propTypes = propTypes;
SuggestionsMedias.defaultProps = defaultProps;
SuggestionsMedias.contextTypes = contextTypes;

export default SuggestionsMedias;



// WEBPACK FOOTER //
// ./src/app/components/singles/parts/SuggestionsMedias.js